// extracted by mini-css-extract-plugin
export default {"root":"app-core-components-form-components-SwitchField-SwitchField-module__root","label":"app-core-components-form-components-SwitchField-SwitchField-module__label"};